<template>
  <div class="message-unavailable">
    {{ message }}
    <unstyled-button v-if="showRestore" class="restore-button" :title="restoreButtonTitle" @click="restoreMessage">
      <i class="icon-ccw" />
    </unstyled-button>
  </div>
</template>

<script>
import UnstyledButton from '../components/buttons/unstyled-button'
import { mapState } from 'vuex'

export default {
  components: { UnstyledButton },

  props: {
    unavailableReason: {
      type: String,
      required: true,
      validator: value => ['logically_deleted', 'physically_deleted', 'pending_review'].includes(value)
    },
    id: {
      type: [Number, null],
      required: true
    },
    threadId: {
      type: Number,
      required: true
    },
    restoreButtonTitle: {
      type: String,
      required: true
    }
  },

  emits: ['restore'],

  computed: {
    ...mapState(['canDelete']),

    message() {
      if (this.unavailableReason === 'logically_deleted' ||
          this.unavailableReason === 'physically_deleted') {
        return this.i18n.t('member.forums.deleted_message')
      } else {
        return this.i18n.t('member.forums.unavailable_message')
      }
    },

    showRestore()  {
      return this.canDelete && this.unavailableReason === 'logically_deleted'
    }
  },

  methods: {
    restoreMessage() {
      this.$emit('restore', {threadId: this.threadId, messageId: this.id})
    }
  }
}
</script>

<style scoped lang="scss">
  .message-unavailable {
    display: flex;
    align-items: center;
    min-height: 50px;
    padding: 10px;
  }
</style>
